import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { clearSelectedThread } from '../../selected-thread/actions/clearSelectedThread';
import { updateView } from '../../current-view/actions/updateView';
import { KNOWLEDGE_BASE, THREAD_LIST, CATEGORY_VIEW } from '../../current-view/constants/views';
import { getIsUngatedForKBInWidget } from '../../widget-data/selectors/widgetDataSelectors';
import { getCurrentView } from '../../current-view/selectors/getCurrentView';
export function navigateToThreadListKnowledgebase() {
  return (dispatch, getState) => {
    const currentView = getCurrentView(getState());
    dispatch(clearSelectedThread());
    if (getIsUngatedForKBInWidget(getState()) && currentView !== CATEGORY_VIEW) {
      //set default view to chat for new kb
      dispatch(updateView(THREAD_LIST));
    } else {
      dispatch(updateView(KNOWLEDGE_BASE));
    }
    dispatch(trackInteraction('widget-interaction', {
      action: 'view thread list'
    }));
  };
}